import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';

import { PaceEffects } from './pace.effects';
import { paceFeature } from './pace.reducer';

export const paceStore = [
  provideState(paceFeature),
  provideEffects(PaceEffects),
];
